import apiClient from "./apiService";
import environment from "../config/environment";

const SECRET_SOFTWARE_KEY = environment.secretSoftwareKey;

const getSecretHeaders = (extraHeaders = {}) => ({
	"X-Secret-Software-Key": SECRET_SOFTWARE_KEY,
	"Content-Type": "application/json",
	Accept: "application/json",
	...extraHeaders,
});

export const authService = {
	setLocalStorage(container, token) {
		localStorage.setItem(container, token);
	},

	getToken() {
		return localStorage.getItem("jwt_token");
	},

	removeToken() {
		localStorage.removeItem("jwt_token");
		localStorage.removeItem("user_data");
	},

	async login(username, password) {
		try {
			const response = await apiClient.post("/auth/login", { username, password }, { headers: getSecretHeaders() });

			if (response.data.data && response.data.data.jwt) {
				this.setLocalStorage("jwt_token", response.data.data.jwt);
				this.setLocalStorage("user_data", JSON.stringify(response.data.user_data));
			}
			return response.data;
		} catch (error) {
			throw new Error("Login failed: " + (error.response?.data?.message || error.message));
		}
	},

	async checkAuth() {
		const token = this.getToken();
		if (!token) return false;

		try {
			const response = await apiClient.post("/auth/validate_token", { token }, { headers: getSecretHeaders() });

			if (response.data.status !== "ok") {
				this.removeToken();
				return false;
			}
			return true;
		} catch (error) {
			console.error("Token check failed:", error);
			return false;
		}
	},

	// async logout() {
	// 	try {
	// 		await apiClient.post("/logout", {}, { headers: getSecretHeaders() });
	// 	} catch (error) {
	// 		console.error("Logout error:", error);
	// 	} finally {
	// 		this.removeToken();
	// 	}
	// },
};
